"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = LoginPage;
var jsx_runtime_1 = require("react/jsx-runtime");
function LoginPage() {
    return (0, jsx_runtime_1.jsx)("div", { children: "Login Page" });
}
